import { useState, Dispatch, SetStateAction } from 'react';

import { isProduction } from '@/settings/environment';

export type CapyValues = {
  capyChallengekey: string;
  capyAnswer: string;
};

export type SetCapyValues = Dispatch<SetStateAction<CapyValues>>;

type CreateParamsWithCapyValues = <
  T extends {
    ignoreCapyCaptcha?: boolean | undefined;
  },
>(
  values: T,
) => Omit<T, 'ignoreCapyCaptcha'> & CapyValues;

type UseCapyValues = {
  capyValues: CapyValues;
  setCapyValues: SetCapyValues;
  createParamsWithCapyValues: CreateParamsWithCapyValues;
};

export const useCapyValues = (): UseCapyValues => {
  const [capyValues, setCapyValues] = useState<CapyValues>({
    capyChallengekey: '',
    capyAnswer: '',
  });

  const createParamsWithCapyValues: CreateParamsWithCapyValues = (values) => {
    const { ignoreCapyCaptcha, ...restValues } = values;

    // Not本番環境 かつ 「Capyをスルーする」がtrueの場合、バイパスのトークンを使用する
    if (!isProduction() && ignoreCapyCaptcha) {
      return {
        ...restValues,
        capyChallengekey:
          process.env.REACT_APP_BYPASS_CAPTCHA_VERIFICATION_TOKEN,
        capyAnswer: process.env.REACT_APP_BYPASS_CAPTCHA_VERIFICATION_TOKEN,
      };
    } else {
      return {
        ...restValues,
        ...capyValues,
      };
    }
  };

  return {
    capyValues,
    setCapyValues,
    createParamsWithCapyValues,
  };
};
